import React from "react";
import { StyledCardBody } from "./CardBody.styles";

const CardBody = ({ children }) => {
  return <StyledCardBody>{children}</StyledCardBody>;
};

export default CardBody;
